<template>
  <transition name="el-fade-in-linear">
	<div v-show="transitionshow">      
	  	
	  <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item>
		  	  <el-input type="text" size="small" v-model="query.key" clearable  placeholder="请输入抖店ID / skuid / 商品名称" @change="query.ischange=true"/>
		  </el-form-item>
          <el-form-item>
		  	  <el-button type="primary" size="small" round @click="getlists">搜索</el-button>
		  </el-form-item>
          <el-form-item>
		  	  <el-button type="danger" icon="el-icon-edit-outline" size="small" round @click="addmatchgoods">新增匹配商品</el-button>
		  </el-form-item>
          <el-form-item>
		  	  <el-button type="success" icon="el-icon-upload2" size="small" round @click="importgoodsDshop">批量导入抖店商品</el-button>
		  </el-form-item>
	  </el-form>

      <div class="backborder2" style="margin-top:10px">
      <el-table :data="lists" v-loading="query.loading">
          <el-table-column label="ID" width="100" align="center">
              <template slot-scope="scope">
                 <div class="dshop-goods-name">{{scope.row.id}}</div>
              </template>
          </el-table-column>
          <el-table-column label="所属店铺" width="170">
              <template slot-scope="scope">
                 <div class="dshop-goods-name">{{scope.row.dshopname}}</div>
              </template>
          </el-table-column>
	      <el-table-column label="抖店商品信息">
              <template slot-scope="scope">
                 <div class="dshop-goods-name">{{scope.row.dshopproductname}}（{{scope.row.dshopproductspec}}）</div>
                 <div class="dshop-goods-id">ID：{{scope.row.dshopproductid}}，skuid：{{scope.row.dshopskuid}}</div>
              </template>
          </el-table-column>
          <el-table-column label="关联宠赞商品信息" width="500">
              <template slot-scope="scope">
                 <div class="dshop-goods-infos-lists" v-if="scope.row.goods && scope.row.goods.length > 0">
                    <div class="dshop-goods-infos-lists-infos" v-for="(item,index) in scope.row.goods" :key="index">
                        <div class="dshop-goods-infos-lists-infos-names">
                            <div class="dshop-goods-infos-lists-infos-number">{{item.productname}}</div>
                            <div class="dshop-goods-infos-lists-infos-number" style="font-size:12px;color:#999999">商品ID：{{item.productid}}，编号：{{item.number}}</div>
                        </div>
                        <div class="dshop-goods-infos-lists-infos-unit"> x {{item.nums}} {{item.unit}}</div>
                    </div>
                 </div>
              </template>
          </el-table-column>
          <el-table-column width="120" label="操作" align="center">
              <template slot-scope="scope">
                  <el-button type="primary" size="small" circle icon="el-icon-edit" @click="gettmallgoods(scope.row)"/> 
                  <el-button type="danger" size="small" circle icon="el-icon-delete" @click="delmatchgoods(scope.row)" /> 
              </template>
          </el-table-column>
      </el-table>
      <div class="block">
	        <!--分页begin-->
	        <el-pagination
	            @size-change="pageProductSizeChange"
	            @current-change="pageProductCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="query.rows">
	        </el-pagination>
	        <!--分页end-->
      </div>
      </div>

      <!-- 匹配商品 -->
      <el-dialog title="新增 / 编辑匹配商品信息" :visible.sync="matchGoodsDialog" width="48%" top="10vh" class="dshop-match-goods-infos-back">
            <div class="dshop-match-goods-infos" v-loading="addquery.loading">
            <el-form class="demo-form-inline" size="small">
                <div class="dshop-match-goods-infos-out">
                <div class="dshop-match-goods-infos-title">抖店商品信息</div>
                <el-form-item label="选择店铺" label-width="140">
                    <el-select v-model="addquery.dshopid"  filterable placeholder="请选择抖音店铺">
                        <el-option v-for="(item,index) in dshoplists" :label="item.dshopname" :value="item.id" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品名称" label-width="140">
                    <el-input type="text" size="small" v-model="addquery.dshopproductname"  placeholder="请输入抖店商品名称" />
                </el-form-item>
                <el-form-item label="商品规格" label-width="140">
                    <el-input type="text" size="small" v-model="addquery.dshopproductspec"  placeholder="请输入抖店商品规格" />
                </el-form-item>
                <el-form-item label="商品ID" label-width="140">
                    <el-input type="text" size="small" v-model="addquery.dshopproductid"  placeholder="请输入抖店商品ID" />
                </el-form-item>
                <el-form-item label="商品skuId" label-width="140">
                    <el-input type="text" size="small" v-model="addquery.dshopskuid"  placeholder="请输入抖店skuid" />
                </el-form-item>
                </div>
                <div class="dshop-match-goods-infos-out" style="margin-top:20px">
                <div class="dshop-match-goods-infos-title">
                    宠赞商品信息
                    <el-button type="danger" size="mini" icon="el-icon-plus" circle style="margin-left:2%" @click="getmatchgoods" />
                </div>
                <el-form-item>
                    <div class="dshop-match-goods-lists-no" v-if="addquery.goodsinfos.length==0">
                        <img src="../../assets/packet.png" />
                        <span>您还没有添加匹配的宠赞商品</span>
                    </div>

                    <div class="dshop-match-goods-lists" style="float:left;width:100%" v-if="addquery.goodsinfos.length > 0" v-for="(item,index) in addquery.goodsinfos" :key="index">
                        <div class="dshop-match-goods-names" style="float:left;padding-right:20px;width:calc(40% - 20px);height:50px;font-size:13px;display:flex;justify-content:left;align-items:center">
                            <div class="dshop-match-goods-name" style="float:left;width:100%;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;">{{item.productname}}</div>
                        </div>
                        <div class="dshop-match-goods-names" style="float:left;padding:0 10px;width:calc(20% - 20px);height:50px;font-size:13px;display:flex;justify-content:center;align-items:center">
                            <div class="dshop-match-goods-name" style="float:left;width:100%;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;">
                                {{item.unit}}
                            </div>
                        </div>
                        <div class="dshop-match-goods-names" style="float:left;padding:0 10px;width:calc(20% - 20px);height:50px;font-size:13px;display:flex;justify-content:center;align-items:center">
                            <div class="dshop-match-goods-name" style="float:left;width:100%;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;">
                                <el-input type="text" size="small" v-model="item.nums"  placeholder="设置数量" />
                            </div>
                        </div>
                        <div class="dshop-match-goods-names" style="float:left;padding:0 10px;width:calc(20% - 20px);height:50px;font-size:13px;display:flex;justify-content:center;align-items:center">
                            <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="delgoods($delete(addquery.goodsinfos,index))"/>
                        </div>
                    </div>
                </el-form-item>
                </div>
            </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
			    <el-button type="primary" size="small" @click="savesettings">确定</el-button>
			    <el-button size="small" @click="matchGoodsDialog = false">取 消</el-button>
		    </div>
      </el-dialog>

      <!-- 批量导入抖店商品 -->
      <input id="fileupload" type="file" @change="importfile(this)"  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style="display:none" title="1"/>
      <el-dialog title="批量导入抖店商品" :visible.sync="importgoodsDialog" width="65%" top="10vh">
        <div class="dshop-match-goods-import-notice">温馨提示：此处上传的商品表格为在抖店后台直接导出的商品表格</div>
        <div style="display:inline-block;width:100%" class="dshop-match-goods-import-out-main">
            <div style="width:100%;float:left;">
                <el-form :inline="true" class="demo-form-inline" size="small" style="float:left">
                    <el-form-item label="选择抖店店铺" label-width="140">
                        <el-select v-model="importgoods.dshopid"  filterable placeholder="请选择抖音店铺">
                            <el-option v-for="(item,index) in dshoplists" :label="item.dshopname" :value="item.id" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
			    <el-button size="small" @click="importgoodsDialog = false" style="float:right">取 消</el-button>
                <el-button type="primary" size="small" @click="saveimport" style="float:right;margin-right:1%">确定</el-button>
                <el-button type="warning" size="small" @click="uploadmodel" style="float:right">导入商品</el-button>
                <div class="dshop-match-goods-import-count">共导入商品 {{importgoodslists.length}} 个</div>
		    </div>
            <div class="dshop-match-goods-import-out" v-if="importgoodslists.length > 0" v-loading="importgoods.loading">
                <div class="dshop-match-goods-import-out-titles">
                    <div class="dshop-match-goods-import-out-title dshop-match-goods-import-out-title-wid1 dshop-match-goods-import-out-title-back"><div>商品名称</div></div>
                    <div class="dshop-match-goods-import-out-title dshop-match-goods-import-out-title-wid1 dshop-match-goods-import-out-title-back"><div>商品规格</div></div>
                    <div class="dshop-match-goods-import-out-title dshop-match-goods-import-out-title-wid1 dshop-match-goods-import-out-title-back"><div>ID</div></div>
                    <div class="dshop-match-goods-import-out-title dshop-match-goods-import-out-title-wid1 dshop-match-goods-import-out-title-back"><div>skuid</div></div>
                    <div class="dshop-match-goods-import-out-title dshop-match-goods-import-out-title-wid2 dshop-match-goods-import-out-title-back"><div style="justify-content:center">操作</div></div>
                </div>
                <div class="dshop-match-goods-import-out-titles" v-for="(item,index) in importgoodslists" :key="index">
                    <div class="dshop-match-goods-import-out-title dshop-match-goods-import-out-title-wid1"><div>{{item.goodsname}}</div></div>
                    <div class="dshop-match-goods-import-out-title dshop-match-goods-import-out-title-wid1"><div>{{item.goodsspec}}</div></div>
                    <div class="dshop-match-goods-import-out-title dshop-match-goods-import-out-title-wid1"><div>{{item.goodsid}}</div></div>
                    <div class="dshop-match-goods-import-out-title dshop-match-goods-import-out-title-wid1"><div>{{item.skuid}}</div></div>
                    <div class="dshop-match-goods-import-out-title dshop-match-goods-import-out-title-wid2">
                        <div style="justify-content:center">
                            <el-button type="danger" size="mini" circle icon="el-icon-delete" @click="delselectgoods(index)"></el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dshop-match-goods-import-out-no" v-if="importgoodslists.length==0" v-loading="importgoods.loading">
                <a @click="uploadmodel"><img src="../../assets/import_goods.png" /><span>请导入抖店商品信息</span></a>
            </div>
            <div style="width:100%;margin-top:20px;float:left;">
                <el-form :inline="true" class="demo-form-inline" size="small" style="float:left">
                    <el-form-item label="选择抖店店铺" label-width="140">
                        <el-select v-model="importgoods.dshopid"  filterable placeholder="请选择抖音店铺">
                            <el-option v-for="(item,index) in dshoplists" :label="item.dshopname" :value="item.id" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
			    <el-button size="small" @click="importgoodsDialog = false" style="float:right">取 消</el-button>
                <el-button type="primary" size="small" @click="saveimport" style="float:right;margin-right:1%">确定</el-button>
                <el-button type="warning" size="small" @click="uploadmodel" style="float:right">导入商品</el-button>
                <div class="dshop-match-goods-import-count">共导入商品 {{importgoodslists.length}} 个</div>
		    </div>
        </div>
      </el-dialog>

      <!-- 搜索商品模块 -->
      <product v-model="DDproductshow"  @close="closeproduct" @finish="getgoods"/>


      <!-- 拉取数据加载页 -->
      <div class="dshop-order-down-loading" :style="showorderloading"> 
          <div class="dshop-order-down-loading-main">
              <div class="dshop-order-down-main-notice">上传抖店商品信息需要一点时间，请勿关闭当前页面</div>
              <div class="dshop-order-down-main-percentout">
                  loading...
                  <span class="dshop-order-down-main-percent" :style="loadingpercent"></span>
              </div>
          </div>
      </div>

      <!-- 展示错误信息 -->
      <el-dialog title="错误提示" :visible.sync="errorshowDialog" width="60%" top="10vh">
          <div style="display:inline-block;width:100%;color:red;margin-bottom:20px;font-size:13px;line-height:23px;text-align:right">共计：{{errorshows.length}} 条</div>
          <div class="dshop-order-down-error-shows" v-for="(item,index) in errorshows">
              <img src="../../assets/error.png" />
              {{item}}
          </div>
      </el-dialog>


    </div>
  </transition>  
</template>

<script>
import product from '@/components/doudian/search/product' //获取搜索商品

export default {
  components: {product},
  data () {
    return {
        url:this.GLOBAL.domain+"Dshop/index",
        actionauth:'', //功能权限
		transitionshow:true,
        query: {
            act:'getmatchgoodslists',
            token:this.$cookies.get('token'),
            key:'',
            ischange:false,
            loading:false,
            rows:0,
            p:1,
            rollpage:10
        },
        lists:[],
        addquery: {
            act:'addmatchgoods',
            token:this.$cookies.get('token'),
            dshopid:'',
            dshopproductid:'',
            dshopskuid:'',
            dshopproductname:'',
            dshopproductspec:'',
            goodsinfos:[{productid:'',productname:'',number:'',unitid:'',unit:'',nums:''}],
            loading:false,
        },

        matchGoodsDialog:false,
        dshoplists:[],
        unitlists:[],
        DDproductshow:false,

        importgoods: {
            act:'importgoods',
            token:this.$cookies.get('token'),
            dshopid:'',
            dshopproductname:'',
            dshopproductspec:'',
            dshopproductid:'',
            dshopskuid:'',
            loading:false,
        },
        importgoodslists:[],
        importgoodsDialog:false,

        showorderloading:{display:'none'},
        loadingpercent:{width:'0%'},
        errorshows:[],
        errorshowDialog:false,
		
    }
  },

  watch: {
	  
  },
    
  mounted(){  
      //this.getactionauth();
      this.getshoplists(); //获取抖音店铺列表
      this.getlists(); //获取匹配商品信息列表
  },
  
  methods:{

      //保存导入的商品信息
      saveimport() {
          if(this.importgoods.dshopid=='') {this.$message.error('请选择要导入的店铺');return false;}
          if(this.importgoodslists.length==0) {this.$message.error('请上传要导入的商品');return false;}

          //数据拆包分割，减少http连接数，增加服务器上传成功率
          var importmorepart=[];
          var allrows=this.importgoodslists.length; //数据总条数
          var rollpage=500; //设置单次传输条数
          var p=Math.floor(allrows/rollpage); //获取页数
          (allrows%rollpage) > 0 ? p++ : '';
          
          var startpage=0;
          var endpage=0;
          var data=[];
          var sortinfos=[];
          var _this=this;
          for(var i=0; i<p; i++) {
             sortinfos=[];
             data=[];
             startpage=i*rollpage;
             endpage=(i+1)*rollpage-1;
             while(startpage <= endpage) sortinfos.push(startpage++);
             
             //提取组装数据
             sortinfos.forEach(function(nums,i) {
                 _this.importgoodslists[nums] ? data.push(_this.importgoodslists[nums]) : '';
             });
             importmorepart.push(data);
          }


          //开启加载特效
          this.showorderloading.display='flex';
          this.loadingpercent.width='0%';

          var _this=this;
          var num=0;
          var ordernums=importmorepart.length;
          var result;
          var percent;
          var timenum=0;
          var times=0;
          this.errorshows=[];

          var resource = this.$resource(this.url);
          importmorepart.forEach(function(item,i) {
            timenum++; times=timenum*2000;
            setTimeout(function() {
                num++;
                resource.save({act:'importdshopgoods',token:_this.$cookies.get('token'),dshopid:_this.importgoods.dshopid,data:JSON.stringify(item)}).then((res) => {
                    
                    if(res.data.Result>0) {
                        var errorresult=JSON.parse(res.data.Message);
                        errorresult.forEach(function(itemerror,i) {_this.errorshows.push(itemerror)});
                        if(num!=ordernums) {
                            percent=num/ordernums*100;
                            _this.loadingpercent.width=percent+'%';
                        }
                        if(num==ordernums) {
                            percent=100;
                            _this.loadingpercent.width=percent+'%';
                            _this.showorderloading.display='none'; //关闭特效
                            _this.importgoodsDialog=false;
                            _this.query.p=1;
                            _this.query.rollpage=10;
                            _this.getlists();
                            if(_this.errorshows.length > 0) _this.errorshowDialog=true;
                        }

                    }else {
                        if(num!=ordernums) { //没有加载完时
                            percent=num/ordernums*100;
                            _this.loadingpercent.width=percent+'%';

                        }else { //已经加载完成
                            percent=100;
                            _this.loadingpercent.width=percent+'%';
                            _this.showorderloading.display='none'; //关闭特效
                            _this.importgoodsDialog=false;
                            _this.query.p=1;
                            _this.query.rollpage=10;
                            _this.getlists();
                            if(_this.errorshows.length > 0) _this.errorshowDialog=true;
                        }

                    }

                });

            },times);
          });
      },


      //上传商品模板表格数据
      uploadmodel() {
          document.getElementById("fileupload").click();
      },

      //解析导入文件数据
      importfile(obj) {    
    	  let _this = this;
          let inputDOM = this.$refs.inputer;

          // 通过DOM取文件数据
          this.file = event.currentTarget.files[0];                
          var rABS = false; //是否将文件读取为二进制字符串
          var f = this.file;
          var outdata;
          var nums=0;
          var address='';
          var reader = new FileReader();
          this.importgoodslists=[];
          this.importgoods.loading=true;
          FileReader.prototype.readAsBinaryString = function(f) {
            var binary = "";
            var rABS = false; //是否将文件读取为二进制字符串
            var pt = this;
            var wb; //读取完成的数据
            var reader = new FileReader();
            reader.onload = function(e) {
            	var bytes = new Uint8Array(reader.result);
                var length = bytes.byteLength;
                for(var i = 0; i < length; i++) binary += String.fromCharCode(bytes[i]);
                var XLSX = require('xlsx');
                if(rABS) {
                	wb = XLSX.read(btoa(fixdata(binary)), {type:'base64'});
                }else {
                    wb = XLSX.read(binary, {type: 'binary'});
                }
                outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);//outdata就是你想要的东西
                outdata.forEach(function(item,index) {
                    nums++;
                    if(item['商品ID'] && item['规格ID(SKUID)'] && item['商品名称'] && item['商品规格']) 
                    _this.importgoodslists.push({
                        sort:nums,
                        goodsid:item['商品ID'],
                        skuid:item['规格ID(SKUID)'],
                        goodsname:item['商品名称'],
                        goodsspec:item['商品规格'],
                    });
                });

                //清空输入框的文件值，避免下次change事件失效
                document.getElementById('fileupload').value = null;     
                _this.importgoods.loading=false;      
            }
            reader.readAsArrayBuffer(f);
          }

          if(rABS) {
        	  reader.readAsArrayBuffer(f);
          } else {
              reader.readAsBinaryString(f);
          }    
      },


      //导入抖店商品信息
      importgoodsDshop() {
          this.importgoodsDialog=true;
          this.importgoods.dshopid=this.dshoplists[0].id;
          this.importgoods.dshopproductname='';
          this.importgoods.dshopproductspec='';
          this.importgoods.dshopproductid='';
          this.importgoods.dshopskuid='';
          this.importgoodslists=[];
      },

      //删除导入的抖店商品信息
      delselectgoods(index) {
          this.$delete(this.importgoodslists,index);
      },

      //删除匹配商品
      delmatchgoods(item) {
        this.$confirm('你是否要删除该匹配商品信息 ？', { type: 'warning' }).then(() => {
        	 var resource = this.$resource(this.url);		    
             resource.save({act:'delmatchgoods',token:this.$cookies.get('token'),id:item.id}).then((res) => {
                if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                }else{
                    this.getlists();
                }
             }).catch((res) => {
                
             });

        }).catch(() => {
            
        });  
      },

      //获取匹配商品信息
      gettmallgoods(item) {
          this.matchGoodsDialog=true;
          this.addquery.act='editmatchgoods';
          this.addquery.id='';
          this.addquery.dshopid='';
          this.addquery.dshopproductid='';
          this.addquery.dshopskuid='';
          this.addquery.dshopproductname='';
          this.addquery.dshopproductspec='';
          this.addquery.goodsinfos=[];

          this.addquery.loading=true;
          var resource = this.$resource(this.url);		    
          resource.save({act:'getmatchgoodsinfos',token:this.$cookies.get('token'),id:item.id}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.addquery.loading=false;
              }else{
                  var result = JSON.parse(Base64.decode(res.data.Data));
                  this.addquery.loading=false;
                  this.addquery.id=result.id;
                  this.addquery.dshopid=result.shopid;
                  this.addquery.dshopproductid=result.dshopproductid;
                  this.addquery.dshopskuid=result.dshopskuid;
                  this.addquery.dshopproductname=result.dshopproductname;
                  this.addquery.dshopproductspec=result.dshopproductspec;
                  this.addquery.goodsinfos=result.goodsinfos;
              }
          }).catch((res) => {
              this.addquery.loading=false;
          });

      },


      //保存匹配的宠赞商品信息
      savesettings() {
          this.addquery.loading=true;
          var resource = this.$resource(this.url);		    
          resource.save(this.addquery).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.addquery.loading=false;
              }else{
                  this.addquery.loading=false;
                  this.matchGoodsDialog=false;
                  this.getlists();
              }
          }).catch((res) => {
              this.addquery.loading=false;
          });
      },

      //获取匹配的商品信息
      getmatchgoods() {
          this.DDproductshow=true;
      },

      //关闭选择商品的窗口
      closeproduct() {
          this.DDproductshow=false;
      },

      //获取商品信息
      getgoods(item) {

          var _this=this;  
          var number=-1;
          var unit='';
          this.addquery.goodsinfos.forEach(function(e,index) {
              if(e.productid==item.id && e.unitid==e.unitid) number=index;
          });

          if(number >= 0) return false;

          //获取商品单位信息
          item.units.forEach(function(tt,ii) {
              if(tt.unitid==item.unitid) unit=tt.unit;
          });

          this.addquery.goodsinfos.push({productid:item.id,productname:item.name,number:item.number,unitid:item.unitid,unit:unit,nums:1});
      },

      //获取商品单位信息
      getunit(productid) {
          var resource = this.$resource(this.GLOBAL.domain+"Sell/index");		    
          resource.query({act:'getunit',token:this.$cookies.get('token'),productid:productid}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.unitlists = JSON.parse(Base64.decode(res.data.Data));
                  this.addquery.unitid=this.unitlists[0].id;
              }
          }).catch((res) => {
            
          });
      },

      //打开匹配商品信息
      addmatchgoods() {
          this.matchGoodsDialog=true;
          this.addquery.act='addmatchgoods';
          this.addquery.id='';
          this.addquery.dshopid=this.dshoplists[0].id;
          this.addquery.dshopproductid='';
          this.addquery.dshopskuid='';
          this.addquery.dshopproductname='';
          this.addquery.dshopproductspec='';
          this.addquery.goodsinfos=[];
      },

      //获取设置信息
	  getshoplists() {
		  var resource = this.$resource(this.url);
		  resource.save({act:'getsettinglists',token:this.$cookies.get('token')}).then((res) => {
			  if(res.data.Result>0){
				  if(res.data.Result=='70001') this.$router.push('/login')
				  this.$message.error(res.data.Message);
			  }else{
				  this.dshoplists = JSON.parse(Base64.decode(res.data.Data));
			  }
		  }).catch((res) => {
			  
		  });
	  },

      //获取匹配商品信息列表
      getlists() {
          if(this.query.ischange) {
              this.query.p=1;
              this.query.rollpage=10;
          }
          
          this.query.loading=true;
          var resource = this.$resource(this.url);		    
          resource.save(this.query).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.query.loading=false;
              }else{
                  this.lists = JSON.parse(Base64.decode(res.data.Data));
                  this.query.rows=parseInt(res.data.count);
                  this.query.loading=false;

                  if(this.query.ischange) this.query.ischange=false;
              }
          }).catch((res) => {
              this.query.loading=false;
          });
      },

      pageProductSizeChange(val) {
          this.query.rollpage = val;
          this.getlists();
      },
      pageProductCurrentChange(val) {
          this.query.p = val;
          this.getlists();
      },


   } 
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}

.dshop-match-goods-infos-back .el-dialog {background:#fff}
.dshop-match-goods-infos .el-input {max-width:70%}
.dshop-match-goods-infos-out {display:inline-block;width:calc(100% - 40px);padding:10px 20px;border-radius:6px;background:#F2F6FC;}
.dshop-match-goods-infos-title {display:inline-block;width:100%;padding:10px 0;font-size:14px;line-height:14px;font-weight:540;margin-bottom:20px;border-bottom:1px solid #dddddd;font-style:italic;}

.dshop-goods-name {font-size:13px;line-height:23px;width:100%}
.dshop-goods-id {font-size:12px;line-height:23px;color:#999999;width:100%}
.dshop-match-goods-import-out {display:inline-block;padding:20px;width:calc(100% - 40px);border-top:1px solid #EBEEF5;border-bottom:1px solid #EBEEF5;}
.dshop-match-goods-import-out-main .el-form-item__label {font-size:13px}
.dshop-match-goods-import-out-main .el-input {max-width:70%}

.dshop-match-goods-import-out-titles {display:inline-block;width:100%;font-size:0}
.dshop-match-goods-import-out-title {display:inline-block;font-size:13px;line-height:21px;font-weight:540;}
.dshop-match-goods-import-out-title-back {background:#F2F6FC}
.dshop-match-goods-import-out-title div {display:flex;align-items:center;width:calc(100% - 40px);padding:5px 20px;height:40px;}
.dshop-match-goods-import-out-title-wid1 {width:22.5%;}
.dshop-match-goods-import-out-title-wid2 {width:10%;}
.dshop-match-goods-import-count {float:right;color:red;margin-left:2%;font-size:13px;line-height:23px;padding:5px 0;margin-right:2%}
.dshop-match-goods-import-notice {display:inline-block;width:calc(100% - 40px - 2px);padding:10px 20px;font-size:12px;line-height:12px;background:rgba(221,221,221,.2);border:1px solid rgba(221,221,221,.7);border-radius:6px;color:red;margin-bottom:20px}

.dshop-match-goods-import-out-no {display:flex;justify-content:center;align-items:center;width:100%;height:150px;}
.dshop-match-goods-import-out-no a {float:left;min-width:30%;max-width:60%;padding:20px 10px;cursor:pointer;display:flex;justify-content:center;align-items:center;border:1px dashed #fff;background:#fff;transition:.3s all;border-radius:6px;}
.dshop-match-goods-import-out-no a:hover {border:1px dashed #f56c6c;background:#fef0f0}
.dshop-match-goods-import-out-no img {width:30px;height:30px;}
.dshop-match-goods-import-out-no span {height:30px;font-size:14px;line-height:14px;color:#999999;margin-left:5%;display:flex;align-items:center;}

.dshop-order-down-loading {position:fixed;width:100%;height:100%;top:0;left:0;background:rgba(0,0,0,.9);z-index:10000;display:flex;justify-content:center;align-items:center;}
.dshop-order-down-loading-main {display:inline-block;width:30%;text-align:center;}
.dshop-order-down-main-notice {font-size:13px;line-height:23px;color:#ffdd03;-webkit-animation-timing-function:ease-in-out;-webkit-animation-name:goingdown;-webkit-animation-duration:1000ms;-webkit-animation-iteration-count:infinite;-webkit-animation-direction:alternate;}
.dshop-order-down-main-percentout {width:60%;text-align:center;position:relative;padding:5px;font-size:13px;line-height:23px;border-radius:15px;overflow:hidden;border:1px solid #ffdd03;color:#ffdd03;margin:0 auto;margin-top:20px;}
.dshop-order-down-main-percent {position:absolute;height:100%;background:#ffdd03;border-radius:0 15px 15px 0;transition:.6s all;top:0;left:0;}

@-webkit-keyframes goingdown {
	0% {
	    opacity:0;
	    text-shadow:0 0 0 #ffdd03;
    }
    100% {
	    opacity:1;
    	text-shadow:0 0 10px #ffdd03;
    }
}

.dshop-order-down-error-shows {display:flex;align-items:center;width:calc(100% - 2px - 40px);padding:3px 20px;border:1px solid #f56c6c;background:#fef0f0;font-size:12px;color:#f56c6c;border-radius:6px;line-height:23px;margin-bottom:10px;}
.dshop-order-down-error-shows img {width:20px;height:20px;border-radius:50%;margin-right:10px;}

.dshop-goods-infos-lists {width:100%;display:inline-block;}
.dshop-goods-infos-lists-infos {float:left;width:100%;padding:10px 0;border-bottom:1px dashed #E4E7ED;}
.dshop-goods-infos-lists-infos-names {float:left;width:calc(60% - 10px);padding-right:10px;overflow:hidden;white-space:nowrap;text-overflow: ellipsis;font-size:13px;}
.dshop-goods-infos-lists-infos-number {float:left;width:100%;overflow:hidden;white-space:nowrap;text-overflow: ellipsis;font-size:13px;}
.dshop-goods-infos-lists-infos-unit {float:left;width:calc(40% - 40px);padding:0 20px;height:50px;display:flex;justify-content:center;align-items:center;font-size:13px;}
.dshop-match-goods-names .el-input {max-width:100%}

.dshop-match-goods-lists-no {display:flex;justify-content:center;align-items:center;width:100%;height:100px;}
.dshop-match-goods-lists-no img {width:40px;height:40px;}
.dshop-match-goods-lists-no span {margin-left:2%;font-size:14px;color:#999999;}
</style>


// WEBPACK FOOTER //
// src/components/doudian/DoudianGoods.vue